module.exports = __webpack_public_path__ + "static/media/landing_page_illustration12.326e7b8e.png";